export const SET_ENV_VARIABLES = "SET_ENV_VARIABLES";
export const GET_ENV_VARIABLES = "GET_ENV_VARIABLES";
export const CLEAR_ENV_VARIABLES = "CLEAR_ENV_VARIABLES";
